module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M10-clean-6b2e8d6dc47dec8a8879ecfd7b0478a6.png";